import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@emotion/react';

const ReusableTable = ({ columns = [], rows = [] }) => {
    const theme = useTheme();

  return (
    <TableContainer component={Paper} sx={{bgcolor: theme.palette.secondary.main, borderRadius:"35px"}}>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map(({ label, align = 'center' }, index) => (
              <TableCell key={index} align={align} sx={{color: theme.palette.common.white, fontSize:"16px", borderBottom: `1px solid #FFFFFF17`, borderRight: `1px solid #FFFFFF17`,}}>
                {label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {columns.map(({ key, align = 'center' }, colIndex) => (
                <TableCell key={colIndex} align={align} sx={{color: theme.palette.common.white, fontSize:"16px", borderBottom: `1px solid #FFFFFF17`,  borderRight: `1px solid #FFFFFF17`}}>
                  {row[key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReusableTable;
